import { useEffect, useState } from "react";

const QUERY = "(pointer: coarse)";

/** True on a touch screen, where a tap is easy to make by accident (review 0024 decision 175). */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() => window.matchMedia?.(QUERY).matches === true);
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (media === undefined) return;
    const update = () => setCoarse(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  return coarse;
}
